var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"action"},[_c('div',{staticClass:"cta"},[_c('div',{staticClass:"button",attrs:{"data-type":"icon"},on:{"click":function($event){return _vm.openFilter()}}},[_c('span',{staticClass:"icon xt-filter"}),_vm._v(_vm._s(_vm.localizer.get("MyMectronic.Common.Filter")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }